import {Howl} from 'howler';

export const sounds = {

    // menu
    deck_add_card: function () {
        return new Howl({src: [require('./src/menu/menu_add_card/menu_add_card_1.mp3')]})
    },
    deck_remove_card: function () {
        return new Howl({src: [require('./src/menu/menu_remove_card/menu_remove_card_1.mp3')]})
    },
    menu_close_popup: function () {
        return new Howl({src: [require('./src/menu/menu_close_popup/1.mp3')]})
    },
    menu_open_popup: function () {
        return new Howl({src: [require('./src/menu/menu_open_popup/1.mp3')]})
    },

    // pvp
    start_pvp: function () {
        return new Howl({src: [require('./src/pvp_battle_start/signal_start_battle_box.mp3')]})
    },
    timer_pvp: function () {
        return new Howl({src: [require('./src/battle/timer/signal_timer_time.mp3')]})
    },

    //arena
    seasonProgress: function () {
        return new Howl({src: [require('./src/arena/progress_season_1_short.mp3')]})
    },

    dailyFinish: function () {
        return new Howl({src: [require('./src/arena/daily_3.mp3')]})
    },

    // shop
    open_box: function () {
        return new Howl({src: [require('./src/shop/Progress_booster_opening_1.mp3')]})
    },
    open_box_divine: function () {
        return new Howl({src: [require('./src/shop/divine.mp3')]})
    },


    // midlleware
    cannon: function () {
        return new Howl({src: [require('./src/middleware/cannon/powerful-cannon.mp3')]})
    },
    call: function () {
        return new Howl({src: [require('./src/middleware/call/calling.mp3')]})
    },
    spear: function () {
        return new Howl({src: [require('./src/middleware/spear/spear_1.mp3')]})
    },
    slime: function () {
        return new Howl({src: [require('./src/middleware/slime/slime-splatter-1-220262.mp3')]})
    },
    move_water: function () {
        return new Howl({src: [require('./src/middleware/move_water/move.mp3')]})
    },
    healing: function () {
        return new Howl({src: [require('./src/middleware/middleware_ability_healing/middleware_ability_healing_1.mp3')]})
    },
    dark_damage: function () {
        return new Howl({src: [require('./src/middleware/middleware_ability_dark_damage/middleware_ability_dark_damage_1.mp3')]})
    },
    horde_drums: function () {
        return new Howl({src: [require('./src/middleware/horde_drums/drums.mp3')]})
    },
    totem: function () {
        return new Howl({src: [require('./src/middleware/totem/totem.mp3')]})
    },
    spark_summon: function () {
        return new Howl({src: [require('./src/middleware/middleware_ability_spark/cards_spark_1.mp3')]})
    },
    shock_damage: function () {
        return new Howl({src: [require('./src/middleware/middleware_ability_shock/middleware_ability_shock_1.mp3')]})
    },
    uin_stun: function(){
        return new Howl({src: [require('./src/cards/Uin/Goblin_warlord_ability_1.mp3')]})
    },
    jul_chain: function () {
        return new Howl({src: [require('./src/middleware/Jul_chain/3.mp3')]})
    },
    vampires: function () {
        return new Howl({src: [require('./src/middleware/vampires/1.mp3')]})
    },
    gunner: function () {
        return new Howl({src: [require('./src/middleware/sea_adv/cannon-shot-14799.mp3')]})
    },
    doctor: function () {
        return new Howl({src: [require('./src/middleware/sea_adv/shaking-a-pill-bottle-281273.mp3')]})
    },
    navigator: function () {
        return new Howl({src: [require('./src/middleware/sea_adv/card-sounds-35956.mp3')]})
    },
    buccaneer: function () {
        return new Howl({src: [require('./src/cards/Buccaneer/musket-shot-86526_nLCa9KvB.mp3')]})
    },
    rat: function () {
        return new Howl({src: [require('./src/cards/rats/rat-eats.mp3')]})
    },
    stone_golem_summon: function () {
        return new Howl({src: [require('./src/cards/golems/stone.mp3')]})
    },
    wind_golem_summon: function () {
        return new Howl({src: [require('./src/cards/golems/wind.mp3')]})
    },
    spark_golem_summon: function () {
        return new Howl({src: [require('./src/cards/golems/fire.mp3')]})
    },
    // midlleware end


    getMenuRandomMusic: function () {
        let src = [require('./src/menu/menu_theme/1.mp3'), require('./src/menu/menu_theme/2.mp3'), require('./src/menu/menu_theme/3.mp3')];
        return src[Math.floor(Math.random() * 3)];
    },

    getBattleRandomMusic: function () {
        let src = [require('./src/battle/battle_theme/1.mp3'), require('./src/battle/battle_theme/2.mp3'), require('./src/battle/battle_theme/3.mp3'), require('./src/battle/battle_theme/4.mp3'), require('./src/battle/battle_theme/5.mp3')];
        return src[Math.floor(Math.random() * 5)];
    },

    getTutorialRandomMusic: function () {
        let src = [require('./src/tutorial_theme/tutorial_theme_1.mp3'), require('./src/tutorial_theme/tutorial_theme_2.mp3')];
        return src[Math.floor(Math.random() * 2)];
    },

    getZombieRandomSound: function () {
        let src = [require('./src/cards/Zombie/1045_1.mp3'), require('./src/cards/Zombie/1045_2.mp3'), require('./src/cards/Zombie/1045_3.mp3'), require('./src/cards/Zombie/1045_4.mp3')];
        return src[Math.floor(Math.random() * 4)];
    },

    getPortRatsRandomSound: function () {
        let src = [require('./src/cards/cards_port_rats/cards_port_rats_1.mp3'), require('./src/cards/cards_port_rats/cards_port_rats_2.mp3'), require('./src/cards/cards_port_rats/cards_port_rats_3.mp3'), require('./src/cards/cards_port_rats/cards_port_rats_4.mp3'), require('./src/cards/cards_port_rats/cards_port_rats_5.mp3'), require('./src/cards/cards_port_rats/cards_port_rats_6.mp3')];
        return src[Math.floor(Math.random() * 6)];
    },

    getRandomOpenBoxSound: function () {
        //   let src = [require('./src/shop/1.wav'), require('./src/shop/2.wav'), require('./src/shop/3.wav'), require('./src/shop/4.wav')];

        let src = [require('./src/shop/Progress_booster_opening_1.mp3')];
        // return src[Math.floor(Math.random() * 4)];
        return src[0];
    },


    // battle
    battle_play_air_mana: function () {
        return new Howl({src: [require('./src/battle/battle_play_air_mana/battle_play_air_mana_1.mp3')]})
    },
    battle_play_fire_mana: function () {
        return new Howl({src: [require('./src/battle/battle_play_fire_mana/battle_play_fire_mana_1.mp3')]})
    },
    battle_play_earth_mana: function () {
        return new Howl({src: [require('./src/battle/battle_play_earth_mana/battle_play_earth_mana_1.mp3')]})
    },

    battle_play_spell: function () {
        return new Howl({src: [require('./src/battle/battle_play_spell/battle_play_spell_1.mp3')]})
    },
    battle_play_unit: function () {
        return new Howl({src: [require('./src/battle/battle_play_unit/battle_play_unit_1.mp3')]})
    },
    battle_unit_dead: function () {
        return new Howl({src: [require('./src/battle/battle_unit_dead/battle_unit_dead_1.mp3')]})
    },

    battle_end_turn: function () {
        return new Howl({src: [require('./src/battle/battle_end_turn/battle_end_turn_1.mp3')]})
    },
    battle_start_turn: function () {
        return new Howl({src: [require('./src/battle/battle_start_turn/battle_start_turn_1.mp3')]})
    },


    battle_unit_set_attack: function () {
        return new Howl({src: [require('./src/battle/battle_unit_set_attack/battle_unit_set_attack_1.mp3')]})
    },
    battle_unit_set_defence: function () {
        return new Howl({src: [require('./src/battle/battle_unit_set_defence/battle_unit_set_defence_1.mp3')]})
    },
    battle_unit_fight_very_low: function () {
        return new Howl({src: [require('./src/battle/battle_unit_fight/battle_cards_6.mp3')]})
    },
    battle_unit_fight_low: function () {
        return new Howl({src: [require('./src/battle/battle_unit_fight/hit18.mp3.mp3')]})
    },
    battle_unit_fight_medium: function () {
        return new Howl({src: [require('./src/battle/battle_unit_fight/hit19.mp3.mp3')]})
    },
    battle_win: function () {
        return new Howl({src: [require('./src/battle/battle_win/battle_win_1.mp3')]})
    },

    battle_lose: function () {
        return new Howl({src: [require('./src/battle/battle_lose/battle_lose_1.mp3')]})
    },



    zombie: function () {
        return new Howl({src: sounds.getZombieRandomSound()})
    },

    port_rats: function () {
        return new Howl({src: sounds.getPortRatsRandomSound()})
    },


    //cards
    slime_bubble: function () {
        return new Howl({src: [require('./src/cards/Slime/boublbe.mp3')]})
    },
    sucrifice: function () {
        return new Howl({src: [require('./src/cards/sucrifice/sucrifice.mp3')]})
    },
    plague: function () {
        return new Howl({src: [require('./src/cards/plague/plague.mp3')]})
    },
    blood_chain: function () {
        return new Howl({src: [require('./src/cards/blood_chain/chain.mp3')]})
    },
    treasures: function () {
        return new Howl({src: [require('./src/cards/treasures/mystical-chime-196405.mp3')]})
    },
    uin: function () {
        return new Howl({src: [require('./src/cards/Uin/Goblin_warlord_creature_3.mp3')]})
    },
    orkArmor: function () {
        return new Howl({src: [require('./src/cards/OrkArmor/orks_shield_spell_2.mp3')]})
    },
    orkSword: function () {
        return new Howl({src: [require('./src/cards/OrkSword/orks_sword_spell_1.mp3')]})
    },
    stun: function () {
        return new Howl({src: [require('./src/cards/Stun/Stun_effect_ 1.mp3')]})
    },
    troll_guard: function () {
        return new Howl({src: [require('./src/cards/TrollGuard/troll_bodygard_new_1.mp3')]})
    },
    tentacles: function () {
        return new Howl({src: [require('./src/cards/Tentacles/Tentacles_slap.mp3')]})
    },
    acid_spores: function () {
        return new Howl({src: [require('./src/cards/cards_acid_spores/cards_acid_spores_1.mp3')]})
    },
    air_elemental: function () {
        return new Howl({src: [require('./src/cards/cards_air_elemental/cards_air_elemental_1.mp3')]})
    },
    blast: function () {
        return new Howl({src: [require('./src/cards/cards_blast/cards_blast_1.mp3')]})
    },
    blessing: function () {
        return new Howl({src: [require('./src/cards/cards_blessing/cards_blessing_1.mp3')]})
    },
    cat_girl: function () {
        return new Howl({src: [require('./src/cards/cards_cat_girl/cards_cat_girl_1.mp3')]})
    },
    chain_lightning: function () {
        return new Howl({src: [require('./src/cards/cards_chain_lightning/cards_chain_lightning_1.mp3')]})
    },
    cloud: function () {
        return new Howl({src: [require('./src/cards/cards_cloud/cards_cloud_1.mp3')]})
    },
    desperate_passion: function () {
        return new Howl({src: [require('./src/cards/cards_desperate_passion/cards_desperate_passion_1.mp3')]})
    },
    dickfither: function () {
        return new Howl({src: [require('./src/cards/cards_dickfither/cards_dickfither_1.mp3')]})
    },
    dragon_girl: function () {
        return new Howl({src: [require('./src/cards/cards_dragon_girl/cards_dragon_girl_1.mp3')]})
    },
    earth_elemental: function () {
        return new Howl({src: [require('./src/cards/cards_earth_elemental/cards_earth_elemental_1.mp3')]})
    },
    fairy: function () {
        return new Howl({src: [require('./src/cards/cards_fairy/cards_fairy_1.mp3')]})
    },
    fire_bolt: function () {
        return new Howl({src: [require('./src/cards/cards_fire_bolt/cards_fire_bolt_1.mp3')]})
    },
    fire_elemental: function () {
        return new Howl({src: [require('./src/cards/cards_fire_elemental/cards_fire_elemental_1.mp3')]})
    },
    gabriela: function () {
        return new Howl({src: [require('./src/cards/cards_gabriela/cards_gabriela_1.mp3')]})
    },
    healing_potion: function () {
        return new Howl({src: [require('./src/cards/cards_healing_potion/cards_healing_potion_1.wav')]})
    },
    henchman: function () {
        return new Howl({src: [require('./src/cards/cards_henchman/cards_henchman_1.mp3')]})
    },
    horsewoman: function () {
        return new Howl({src: [require('./src/cards/cards_horsewoman/cards_horsewoman_1.mp3')]})
    },
    hurricane: function () {
        return new Howl({src: [require('./src/cards/cards_hurricane/cards_hurricane_1.mp3')]})
    },
    knighthood: function () {
        return new Howl({src: [require('./src/cards/cards_knighthood/cards_knighthood_1.mp3')]})
    },
    lightning: function () {
        return new Howl({src: [require('./src/cards/cards_lightning/cards_lightning_1.mp3')]})
    },
    mad: function () {
        return new Howl({src: [require('./src/cards/cards_mad/cards_mad_1.mp3')]})
    },
    slave: function () {
        return new Howl({src: [require('./src/cards/cards_slave/cards_slave_1.mp3')]})
    },
    snake: function () {
        return new Howl({src: [require('./src/cards/cards_snake/cards_snake_1.mp3')]})
    },
    spikes_love: function () {
        return new Howl({src: [require('./src/cards/cards_spikes_love/cards_spikes_love_1.mp3')]})
    },
    victim: function () {
        return new Howl({src: [require('./src/cards/cards_victim/cards_victim_1.wav')]})
    },
    wall_of_fire: function () {
        return new Howl({src: [require('./src/cards/cards_wall_of_fire/cards_wall_of_fire_1.mp3')]})
    },
    zombie_wizard: function () {
        return new Howl({src: [require('./src/cards/cards_zombie_wizard/cards_zombie_wizard_1.mp3')]})
    },
    sword: function () {
        return new Howl({src: [require('./src/cards/cards_sword/cards_sword_1.mp3')]})
    },
    shield: function () {
        return new Howl({src: [require('./src/cards/cards_shield/cards_shield_1.mp3')]})
    },
    troll: function () {
        return new Howl({src: [require('./src/cards/cards_sexy_troll/cards_sexy_troll_1.mp3')]})
    },


    thief: function () {
        return new Howl({src: [require('./src/cards/cards_thief/cards_thief_1.mp3')]})
    },
    kailis: function () {
        return new Howl({src: [require('./src/cards/cards_kailis/cards_kailis_1.mp3')]})
    },
    robbery: function () {
        return new Howl({src: [require('./src/cards/cards_looting/cards_looting_1.mp3')]})
    },
    riot: function () {
        return new Howl({src: [require('./src/cards/cards_riot/cards_riot_1.mp3')]})
    },

    chimera: function () {
        return new Howl({src: [require('./src/cards/cards_Chimera/cards_Chimera_1.mp3')]})
    },
    lamia: function () {
        return new Howl({src: [require('./src/cards/cards_lamia/cards_lamia_1.mp3')]})
    },
    kailis_heretic: function () {
        return new Howl({src: [require('./src/cards/cards_Kailis_Heretic/cards_Kailis_Heretic_1.mp3')]})
    },
    amulet_of_death: function () {
        return new Howl({src: [require('./src/cards/cards_Amulet_of_death/cards_Magic_Amulet_1.mp3')]})
    },
    wrath_old_god: function () {
        return new Howl({src: [require('./src/cards/cards_Wrath_old_god/cards_Doomsday_1.mp3')]})
    },
    bite: function (){
        return new Howl({src: [require('./src/cards/Bite/female-vampire-bite-1.mp3')]})
    },
    vampire_repast: function (){
        return new Howl({src: [require('./src/cards/Vampire_Repast/munching-sound-1.mp3')]})
    },
    treasure: function () {
        return new Howl({src: [require('./src/cards/treasure/coin-drop-229314.mp3')]})
    },
    ball_lighting: function () {
        return new Howl({src: [require('./src/cards/ball_lighting/thunder-307513_1WPUp33j.mp3')]})
    },
    shackles:function () {
        return new Howl({src: [require('./src/cards/Shackles/086014_dropping-chain-36888.mp3')]})
    },
    sirenes: function () {
        return new Howl({src: [require('./src/cards/Sirenes/angel-ahhh.mp3')]})
    },
    bomb: function () {
        return new Howl({src: [require('./src/cards/Bomb/bomb-explosion-sfx-352274_5V4CAKOL.mp3')]})
    },
    bottle: function () {
        return new Howl({src: [require('./src/cards/Bottle/bottle-open.mp3')]})
    },
    splash: function () {
        return new Howl({src: [require('./src/cards/Walk_the_Plank/splash-by-blaukreuz-6261.mp3')]})
    },
    mermeid:function(){
        return new Howl({src: [require('./src/cards/mermeid/mermaid.mp3')]})
    },
    claws:function(){
        return new Howl({src: [require('./src/effects/claws/claws.mp3')]})
    },
    seagul:function(){
        return new Howl({src: [require('./src/effects/seagull/seagulls.mp3')]})
    },
    lizard:function(){
        return new Howl({src: [require('./src/effects/lizard/lizard.mp3')]})
    },
    //cards end

    // effects
    teacher_draw: function () {
        return new Howl({src: [require('./src/cards/teacher/draw.mp3')]})
    }
};